export enum savedConditionsTypes {
  FETCH_SAVED_CONDITIONS_REQUEST = "FETCH_SAVED_CONDITIONS_REQUEST",
  FETCH_SAVED_CONDITIONS_SUCCESS = "FETCH_SAVED_CONDITIONS_SUCCESS",
  FETCH_SAVED_CONDITIONS_FAILURE = "FETCH_SAVED_CONDITIONS_FAILURE",
}